// Pure predicate for "does this issue need a household PICKER to link a
// realty service record to its real client household?" — the gap Nate
// hit on 2026-07-09: the realty-sr-needs-client-household issue's only
// button ("Apply — Pick the actual client household") POSTed a param-
// less `match`, which the backend correctly rejects (400 target_required)
// because linking IS the action and it needs a target household. No
// picker was ever wired for this detector, so the button spun and dead-
// ended.
//
// This issue is entityKind "service_record" (not "household"), so the
// household-search-merge predicate deliberately returns null for it (it
// merges a source HOUSEHOLD into a destination). The realty link is a
// different backend action — `match` with `target_household_id` (relink
// to an existing client household) or `create_client_household` (rename
// the synthetic stub into a realty-only client household). This predicate
// recognizes exactly that one detector and returns the service-record
// ref the overlay drives.
//
// Deliberately an explicit slug match, not a shape heuristic (same
// convention as household-search-merge-predicate.ts): a service_record +
// `match` shape matching by accident doesn't mean "pick a client
// household" is the right resolution.

export type RecordRef = { kind: string; id: string; label: string };

// Minimal subset of CleanupIssueSummary this predicate inspects.
export interface IssueLike {
  detectorSlug?: string;
  affectedRecords?: RecordRef[];
  recommendation?: { verb: string } | null;
}

export const REALTY_LINK_DETECTOR_SLUG = "realty-sr-needs-client-household";

// Returns the service-record ref the realty-link overlay operates on, or
// null when this isn't a realty-link issue.
export function realtyLinkSource(issue: IssueLike): RecordRef | null {
  if (issue.detectorSlug !== REALTY_LINK_DETECTOR_SLUG) return null;
  if (issue.recommendation?.verb !== "match") return null;
  return (
    (issue.affectedRecords ?? []).find((r) => r.kind === "service_record") ??
    null
  );
}
